export const translations = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      gallery: "Gallery",
      testimonials: "Reviews",
      areas: "Service Areas",
      contact: "Contact",
      cta: "Free Estimate",
    },
    hero: {
      eyebrow: "Birmingham, Alabama · Commercial & Residential · Licensed & Insured",
      title1: "Quality Built.",
      title2: "Solid as Rock.",
      sub: "Commercial and residential construction specialists delivering framing, drywall, painting, finishing, acoustic ceilings, and flooring across Birmingham and surrounding areas.",
      ctaPrimary: "Request Free Estimate",
      ctaSecondary: "View Services",
      stat1: "Years Experience",
      stat2: "Projects Completed",
      stat3: "Satisfied Clients",
    },
    marquee: ["Framing", "Drywall", "Painting", "Finishing", "Acoustic Ceilings", "Flooring", "Licensed", "Insured", "Free Estimates"],
    about: {
      label: "About Us",
      title: "Built on craftsmanship,\nproven by results.",
      body1: "At Black Rock Construction Services LLC, we take pride in delivering quality craftsmanship and dependable service on both commercial and residential projects throughout Birmingham and surrounding areas.",
      body2: "With years of hands-on experience across office build-outs, retail spaces, and homes, we specialize in framing, drywall installation, painting, finishing, acoustic ceilings, and flooring. Our goal is simple: high-quality work, honest communication, and reliable results — every single project.",
      tag: "Quality Built. Solid as Rock.",
    },
    services: {
      label: "Our Services",
      title: "Six trades.\nOne dependable crew.",
      items: [
        { name: "Framing", desc: "Professional wood and metal framing for commercial and residential projects." },
        { name: "Drywall", desc: "Installation, repair, finishing, and texture matching." },
        { name: "Painting", desc: "Interior and exterior painting with professional finishes." },
        { name: "Finishing", desc: "Trim, baseboards, crown molding, and final details." },
        { name: "Acoustic Ceilings", desc: "Installation and replacement of suspended ceiling systems." },
        { name: "Flooring", desc: "Tile, hardwood, laminate, vinyl and custom flooring installations." },
      ],
    },
    why: {
      label: "Why Choose Us",
      title: "No shortcuts. No excuses.",
      items: [
        { t: "Experienced Team", d: "Skilled tradesmen with years on the tools." },
        { t: "Reliable Service", d: "On time, on budget, and on point — every job." },
        { t: "Competitive Pricing", d: "Honest quotes with no hidden fees." },
        { t: "Free Estimates", d: "Detailed walk-through and written quote at no cost." },
        { t: "Quality Workmanship", d: "Built to last — solid as the rock we’re named for." },
        { t: "Customer Satisfaction", d: "We don’t leave until you’re happy." },
      ],
    },
    gallery: {
      label: "Recent Work",
      title: "Real projects.\nReal results.",
      sub: "A glimpse of recent residential work across Birmingham. Photos updated as projects complete.",
      tags: ["Before & After", "Drywall", "Painting", "Flooring"],
    },
    testimonials: {
      label: "What Clients Say",
      title: "Trusted by Birmingham homeowners.",
      items: [
        { quote: "Black Rock reframed and drywalled an addition for us — clean, on schedule, and the finish work is top-notch.", name: "Marcus T.", area: "Homewood, AL" },
        { quote: "They retiled our entire kitchen and bath. Crew was respectful, the work is flawless, and the price was fair.", name: "Anita R.", area: "Hoover, AL" },
        { quote: "Roof repair done right after storm damage. Showed up when they said and stood behind the work.", name: "David L.", area: "Vestavia Hills, AL" },
      ],
    },
    areas: {
      label: "Service Areas",
      title: "Serving Birmingham\n& surrounding communities.",
      list: ["Birmingham", "Hoover", "Vestavia Hills", "Homewood", "Mountain Brook", "Trussville", "Pelham", "Alabaster", "Bessemer", "Helena", "Chelsea", "Gardendale"],
    },
    contact: {
      label: "Get In Touch",
      title: "Request your free estimate.",
      sub: "Tell us about your project. We’ll get back within one business day.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      service: "Service needed",
      pickService: "Select a service",
      address: "Project address (optional)",
      message: "Describe your project",
      submit: "Send Request",
      sending: "Sending...",
      successTitle: "Request received",
      successDesc: "We’ll reach out within one business day. Thanks for choosing Black Rock.",
      errorTitle: "Something went wrong",
      errorDesc: "Please try again or call us at (205) 538-3654.",
      phoneLabel: "Call",
      emailLabel: "Email",
      locationLabel: "Based in",
    },
    footer: {
      tagline: "Quality Built. Solid as Rock.",
      rights: "All rights reserved.",
      licensed: "Licensed & Insured",
    },
  },
  es: {
    nav: {
      about: "Nosotros",
      services: "Servicios",
      gallery: "Galería",
      testimonials: "Reseñas",
      areas: "Áreas",
      contact: "Contacto",
      cta: "Cotización Gratis",
    },
    hero: {
      eyebrow: "Birmingham, Alabama · Comercial y Residencial · Licencia y Seguro",
      title1: "Calidad Construida.",
      title2: "Sólido como Roca.",
      sub: "Especialistas en construcción comercial y residencial: armazón, drywall, pintura, acabados, plafones y pisos en Birmingham y áreas cercanas.",
      ctaPrimary: "Solicitar Cotización Gratis",
      ctaSecondary: "Ver Servicios",
      stat1: "Años de Experiencia",
      stat2: "Proyectos Completados",
      stat3: "Clientes Satisfechos",
    },
    marquee: ["Armazón", "Drywall", "Pintura", "Acabados", "Plafones", "Pisos", "Con Licencia", "Asegurado", "Cotizaciones Gratis"],
    about: {
      label: "Nosotros",
      title: "Construido con oficio,\nprobado en resultados.",
      body1: "En Black Rock Construction Services LLC nos enorgullece entregar trabajo de calidad y un servicio confiable en proyectos comerciales y residenciales en Birmingham y zonas cercanas.",
      body2: "Con años de experiencia en remodelaciones de oficinas, locales comerciales y hogares, nos especializamos en armazón, instalación de drywall, pintura, acabados, plafones acústicos y pisos. Nuestro objetivo es simple: trabajo de calidad, comunicación honesta y resultados confiables — en cada proyecto.",
      tag: "Calidad Construida. Sólido como Roca.",
    },
    services: {
      label: "Nuestros Servicios",
      title: "Seis oficios.\nUn equipo confiable.",
      items: [
        { name: "Armazón", desc: "Armazón profesional en madera y metal para proyectos comerciales y residenciales." },
        { name: "Drywall", desc: "Instalación, reparación, acabado y emparejado de texturas." },
        { name: "Pintura", desc: "Pintura interior y exterior con acabados profesionales." },
        { name: "Acabados", desc: "Molduras, zócalos, cornisas y detalles finales." },
        { name: "Plafones Acústicos", desc: "Instalación y reemplazo de sistemas de plafón suspendido." },
        { name: "Pisos", desc: "Cerámica, madera, laminado, vinilo e instalaciones a medida." },
      ],
    },
    why: {
      label: "Por Qué Elegirnos",
      title: "Sin atajos. Sin excusas.",
      items: [
        { t: "Equipo Experimentado", d: "Maestros con años de oficio." },
        { t: "Servicio Confiable", d: "A tiempo, dentro del presupuesto, siempre." },
        { t: "Precios Competitivos", d: "Cotizaciones honestas y sin sorpresas." },
        { t: "Cotizaciones Gratis", d: "Visita y presupuesto detallado sin costo." },
        { t: "Trabajo de Calidad", d: "Construido para durar — sólido como roca." },
        { t: "Satisfacción Garantizada", d: "No nos vamos hasta que esté satisfecho." },
      ],
    },
    gallery: {
      label: "Trabajos Recientes",
      title: "Proyectos reales.\nResultados reales.",
      sub: "Un vistazo a trabajos residenciales recientes en Birmingham. Fotos actualizadas conforme se completan proyectos.",
      tags: ["Antes y Después", "Drywall", "Pintura", "Pisos"],
    },
    testimonials: {
      label: "Lo Que Dicen",
      title: "De confianza para los dueños de casa en Birmingham.",
      items: [
        { quote: "Black Rock hizo el armazón y el drywall de nuestra ampliación — limpio, a tiempo, con acabados de primera.", name: "Marcus T.", area: "Homewood, AL" },
        { quote: "Renovaron toda la cerámica de la cocina y baño. El equipo fue respetuoso, el trabajo impecable y el precio justo.", name: "Anita R.", area: "Hoover, AL" },
        { quote: "Reparación de techo bien hecha tras la tormenta. Llegaron cuando dijeron y respaldaron su trabajo.", name: "David L.", area: "Vestavia Hills, AL" },
      ],
    },
    areas: {
      label: "Áreas de Servicio",
      title: "Birmingham y\ncomunidades cercanas.",
      list: ["Birmingham", "Hoover", "Vestavia Hills", "Homewood", "Mountain Brook", "Trussville", "Pelham", "Alabaster", "Bessemer", "Helena", "Chelsea", "Gardendale"],
    },
    contact: {
      label: "Contáctanos",
      title: "Solicita tu cotización gratis.",
      sub: "Cuéntanos sobre tu proyecto. Respondemos dentro de un día hábil.",
      name: "Nombre completo",
      email: "Correo",
      phone: "Teléfono",
      service: "Servicio requerido",
      pickService: "Selecciona un servicio",
      address: "Dirección del proyecto (opcional)",
      message: "Describe tu proyecto",
      submit: "Enviar Solicitud",
      sending: "Enviando...",
      successTitle: "Solicitud recibida",
      successDesc: "Te contactaremos en un día hábil. Gracias por elegir Black Rock.",
      errorTitle: "Algo salió mal",
      errorDesc: "Inténtalo de nuevo o llámanos al (205) 538-3654.",
      phoneLabel: "Llamar",
      emailLabel: "Correo",
      locationLabel: "Ubicación",
    },
    footer: {
      tagline: "Calidad Construida. Sólido como Roca.",
      rights: "Todos los derechos reservados.",
      licensed: "Con Licencia y Asegurado",
    },
  },
};
